/* eslint-disable no-console */
import React, { useState } from 'react';
import '../meetingInfoPopup/styles.css';
import { withRoomContext } from '../../../RoomContext';
import { CopyToClipboard } from 'react-copy-to-clipboard';

function WebinarMeetInfo(props)
{

	const { webinarData, setOpen, handlespeakerOpen }=props;
	const [ isCopy, setisCopy ] = useState(false);

	console.log('mmmmmmmmmmmmmmm', webinarData);

	const meetinglink = `https://${window.location.hostname}/register?id=${webinarData._id}&sessionId=${webinarData.sessionId}`;

	const handleClose = () =>
	{
		// props?.roomClient.closeMeetingInfo();
		setOpen(false);
	};

	const closeCopySuccessText = () =>
	{
		setTimeout(() =>
		{
			setisCopy(false);
		}, 1000);
	};

	const handleCopy = (link) =>
	{
		setisCopy(link);
		closeCopySuccessText();
	};

	return (
		<div className='flexCol dialogBD'>
			<div className='flexCol dialogBox'>
				<div className='flexRow jBtwn aCntr brdrBSM pdngSM '>
					<div className='flexMinWidthRow pdngHSM'>

						<span className='mHdng'>Webinar Info</span>
					</div>
					<div className='flexAutoRow pdngHXS'>

						<img
							src='/images/cancel.svg'
							alt='cancel'
							className='IconImage pointer'
							onClick={() => handleClose()}
						/>
					</div>
				</div>
				<div className='flexCol pdngSM '>
					<div className='flexAutoCol pdngXS'>
						<span className='pdngBXS'>Webinar Name</span>
						<span className='txtBlBoldSM capTxt'>{webinarData.meetingName}</span>
					</div>
					{/* <div className='flexAutoCol pdngXS'>
						<span className=' pdngBXS'>Webinar ID</span>
						<div className='flexRow'>
							<div className=' flexMinWidthRow aCntr'>
								<span className='  txtBlBoldSM'>{webinarData.uniqueMeetingID}</span>
							</div>
							<div className='flexAutoRow pointer pRel'>
								<CopyToClipboard text={webinarData.uniqueMeetingID}>
									<img src='/images/copy.svg' className='IconBtn ' alt='copy' onClick={() => handleCopy(webinarData.uniqueMeetingID)} />
								</CopyToClipboard>
								{isCopy === webinarData.uniqueMeetingID && <div className='copiedNotification'>
									<b>Copied!</b>
								</div>}
							</div>
						</div>
					</div> */}
					{!webinarData.withRegistration && <div className='flexAutoCol pdngXS'>
						<span className=' pdngBXS'>Webinar Link</span>
						<div className='flexRow'>
							<div className=' flexMinWidthRow aCntr'>
								<span className='link ellipse'>{meetinglink}</span>
							</div>
							<div className='flexAutoRow pointer pRel'>
								<CopyToClipboard text={meetinglink}>
									<img src='/images/copy.svg' className='IconBtn ' alt='copy' onClick={() => handleCopy(meetinglink)} />
								</CopyToClipboard>
								{isCopy === meetinglink && <div className='copiedNotification'>
									<b>Copied!</b>
								</div>}
							</div>
						</div>
					</div>}
					<div className='flexAutoCol pdngXS'>
						<span className=' pdngBXS'>Speakers</span>
						<div className='flexRow'>
							<div className='flexMinWidthRow aCntr'>
								<span className='link'>{webinarData.speakersData?.length}</span>
							</div>
							<div className='flexAutoRow pointer pRel'>
								<span className='link sHdng' onClick={() => { handleClose(); handlespeakerOpen(); }}>view</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default withRoomContext(WebinarMeetInfo);
